<app-user-tasks class="subpage-content" [folderId]="folderStore.folderId()"></app-user-tasks>

<div #dialogFooter></div>
